<script lang="ts">
	import { Button } from '$lib/components/ui/button';
	import { page } from '$app/stores';
	import '../app.css';
</script>

<main class="container flex min-h-svh items-center justify-center py-20">
	<div class="flex flex-col items-center gap-4 text-pretty text-center">
		{#if $page.status === 404}
			<h1 class="text-2xl font-semibold md:text-4xl">
				Leider konnten wir diese Seite nicht finden.
			</h1>
		{:else}
			<h1 class="text-2xl font-semibold md:text-4xl">{$page.status}: {$page.error?.message}</h1>
		{/if}
		<Button href="/" class="w-fit">Zurück zur Startseite</Button>
	</div>
</main>
